module.exports = __webpack_public_path__ + "static/media/ansv_licencias_libro_senales_de_transito.5c544f72.pdf";